<template>
    <div>
        <div class="flex items-center">
            <p
                v-if="label"
                class="text-left text-lg text-white"
            >
                {{ label }}
            </p>

            <Badge
                v-if="badge"
                class="mb-1 ml-2 self-auto"
                :text="badge"
                color="blue"
            />
        </div>

        <div class="flex items-center space-x-3">
            <input
                type="range"
                :disabled="disabled"
                :name="name"
                :value="modelValue"
                :min="min"
                :max="max"
                class="grow"
                @input="$emit('update:modelValue', $event.target.value)"
            />
            <div class="w-2 text-xl text-white">
                {{ modelValue }}
            </div>
        </div>
    </div>
</template>

<script>
import Badge from './Badge.vue';

export default {
    name: 'FeConfiguratorRange',
    components: { Badge },
    props: {
        name: { type: String, required: true },
        modelValue: { type: Number, default: null },
        label: { type: String, default: '' },
        badge: { type: String, default: '' },
        unit: { type: String, default: '' },
        min: { type: Number, default: 1 },
        max: { type: Number, required: true },
        disabled: { type: Boolean, default: false },
    },
    emits: ['update:modelValue'],
};
</script>
